var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"upcoming-info"},[_c('v-col',{attrs:{"sm":"6","xs":"12"}},[(_vm.alarm)?_c('span',{staticClass:"asterisk"},[_vm._v("* ")]):_vm._e(),_vm._v(_vm._s(_vm.param)+" ")]),_c('v-col',{attrs:{"sm":"6","xs":"12"}},[_vm._v(" "+_vm._s(_vm.value)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }